import type { ReactNode } from "react"

import { Card, CardContent } from "@/components/ui/card"

/**
 * OKS-515 — §12 single state card.
 *
 * The at-risk / frozen / broken states replace the active body (THIS WEEK +
 * freeze + badge-progress) with ONE card carrying a title, a line of copy,
 * and the state's CTA(s) (UX Spec §3). Presentational wrapper — the page
 * supplies the per-state copy + actions so the routing/disabled rules live
 * in one place.
 */
interface StreakStateCardProps {
  title: string
  body: string
  /** CTA button(s) for this state. */
  actions: ReactNode
  testId?: string
}

export function StreakStateCard({
  title,
  body,
  actions,
  testId = "streak-state-card",
}: StreakStateCardProps) {
  return (
    <Card data-testid={testId}>
      <CardContent className="flex flex-col gap-3 py-5">
        <h2 className="text-base font-semibold">{title}</h2>
        <p className="text-muted-foreground text-sm">{body}</p>
        <div className="mt-1 flex flex-col gap-2">{actions}</div>
      </CardContent>
    </Card>
  )
}
